import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { Link, useNavigation, useSearchParams } from '@remix-run/react';
import { cn, useDebounce } from '@theprintbar/shared';
import { useCallback, useEffect, useState } from 'react';
import { Spinner } from '../Spinner';

interface SearchProps {
	currentSearch?: string;
	generateUrl: (search: string) => string;
	className?: string;
	containerClassName?: string;
	iconClassName?: string;
	placeholder?: string;
}

export function SearchBar({ className, containerClassName, iconClassName, placeholder, currentSearch, generateUrl }: SearchProps) {
	const [searchValue, setSearchValue] = useState<any>(currentSearch || '');
	let [debouncedSearch, isDebouncing] = useDebounce(searchValue, 500);
	const [, setSearchParams] = useSearchParams();
	const isNavigating = useNavigation().state !== 'idle';

	const handleDebounce = useCallback(() => {
		if (debouncedSearch !== currentSearch) {
			setSearchParams(generateUrl(debouncedSearch));
		}
	}, [debouncedSearch, currentSearch]);

	//Debounc the searchInput
	useEffect(handleDebounce, [debouncedSearch]);

	return (
		<div className={cn('relative flex-1 max-w-96 ml-8', containerClassName)}>
			<input
				type="text"
				value={searchValue}
				onChange={e => setSearchValue(e.target.value)}
				placeholder={placeholder || 'Search'}
				className={cn('flex-1 h-8 rounded-3xl border border-blue px-3 bg-transparent w-full placeholder:text-blue', className)}
			/>
			<div className="absolute inset-y-0 right-0 flex items-center">
				{!!searchValue && (isDebouncing || (debouncedSearch && isNavigating)) ? (
					<Spinner className="w-4 h-4 text-blue ml-1 mr-3" />
				) : searchValue ? (
					<Link
						to={generateUrl('')}
						onClick={() => setSearchValue('')}
						className="w-full h-full flex items-center justify-center  pl-1 pr-3"
					>
						<XMarkIcon className={cn('w-4 h-4 text-blue', iconClassName)} />
					</Link>
				) : (
					<MagnifyingGlassIcon className={cn(' ml-1 mr-3 w-4 h-4 text-blue', iconClassName)} />
				)}
			</div>
		</div>
	);
}
